import React from "react";
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Grid,
  Radio,
  RadioGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import AddressAutocomplete from "./addressAutocomplete";
import { useTheme } from "@emotion/react";

export default function StepTwo({
  addressComponents,
  setAddressComponents,
  email,
  setEmail,
  requestType,
  setRequestType,
  guarantees,
  toggleGuarantee,
  privacy,
  setPrivacy,
  onSubmit,
  onBack,
  errors,
}) {
  const availableGuarantees = Object.values({}); // adattalo se necessario
  const theme = useTheme();
  return (
    <Box display="flex" flexDirection="column" gap={4} pb={10}>
      {/* Back button */}
      <Button
        variant="text"
        onClick={onBack}
        sx={{
          alignSelf: "flex-start",
          textTransform: "none",
          fontSize: "0.9rem",
          color: "grey.600",
          "&:hover": { color: "grey.900" },
        }}
      >
        ← Torna indietro
      </Button>

      <Paper
        sx={{
          p: 3,
          backgroundColor:
            theme.palette.mode === "dark" ? "#1B2635" : "#F7F9FC",
        }}
      >
        <Typography
          variant="h6"
          fontWeight="bold"
          color={theme.palette.mode === "dark" ? "#fff" : "#1e3a8a"}
        >
          Completa la richiesta
        </Typography>
      </Paper>

      {/* Address autocomplete */}
      <AddressAutocomplete
        onAddressSelect={setAddressComponents}
        error={errors.address}
        defaultValue={addressComponents?.full_address}
      />

      {/* Email */}
      <Box>
        <Typography variant="body2" fontWeight={600} mb={1}>
          Email *
        </Typography>
        <TextField
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="tuamail@esempio.it"
          type="email"
          error={Boolean(errors.email)}
          helperText={errors.email}
        />
      </Box>

      {/* Request type */}
      <Box>
        <Typography variant="body2" fontWeight={600} mb={1}>
          Tipo Richiesta
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Paper
              onClick={() => setRequestType("basic")}
              sx={{
                p: 2,
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                border:
                  requestType === "basic"
                    ? "2px solid #3b82f6"
                    : "1px solid #e5e7eb",
              }}
            >
              <Radio checked={requestType === "basic"} />
              <Typography ml={1}>Solo RC Auto</Typography>
            </Paper>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Paper
              onClick={() => setRequestType("extended")}
              sx={{
                p: 2,
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                border:
                  requestType === "extended"
                    ? "2px solid #3b82f6"
                    : "1px solid #e5e7eb",
              }}
            >
              <Radio checked={requestType === "extended"} />
              <Typography ml={1}>RCA + Garanzie</Typography>
            </Paper>
          </Grid>
        </Grid>
      </Box>

      {/* Guarantees */}
      {requestType === "extended" && (
        <Paper
          sx={{
            p: 3,
            border: "1px solid #e5e7eb",
          }}
        >
          <Typography variant="body2" fontWeight={600} mb={2}>
            Seleziona Garanzie:
          </Typography>

          <Box display="flex" flexDirection="column" gap={1}>
            {availableGuarantees.map((g) => (
              <FormControlLabel
                key={g}
                control={
                  <Checkbox
                    checked={guarantees.includes(g)}
                    onChange={() => toggleGuarantee(g)}
                  />
                }
                label={g}
              />
            ))}
          </Box>
        </Paper>
      )}

      {/* Privacy */}
      <Paper
        sx={{
          p: 3,
          border: errors.privacy ? "1px solid #fecaca" : "1px solid #e5e7eb",
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={privacy}
              onChange={(e) => setPrivacy(e.target.checked)}
            />
          }
          sx={{ alignItems: "flex-start" }}
          label={
            <Typography variant="body2" color="text.secondary">
              Dichiaro di aver letto e accettato l'
              <a
                href="#"
                style={{ color: "#2563eb", textDecoration: "underline" }}
              >
                informativa privacy
              </a>{" "}
              ai sensi del GDPR. *
            </Typography>
          }
        />
        {errors.privacy && (
          <Typography variant="caption" color="error" sx={{ ml: 4 }}>
            {errors.privacy}
          </Typography>
        )}
      </Paper>

      {/* Submit Button */}
      <Box
        sx={{
          bottom: 0,
          left: 0,
          right: 0,
          p: { xs: 2, lg: 0 },

          borderTop: { xs: "1px solid #e5e7eb", lg: "0" },
        }}
      >
        <Button
          fullWidth
          variant="contained"
          color="success"
          onClick={onSubmit}
          sx={{
            py: 2,
            fontSize: "1.1rem",
            borderRadius: "12px",
          }}
        >
          Invia richiesta preventivo
        </Button>
      </Box>

      <Box height={{ xs: 80, lg: 0 }} />
    </Box>
  );
}
